import React, { ReactNode } from "react";
import { Box, Paper, Typography } from "@mui/material";
import { t } from "i18next";

import "./styles.scss";

interface Props {
  fromValue: string;
  toValue: string;
  label: string;
  icon: ReactNode;
}

const MetricCard: React.FC<Props> = ({ fromValue, toValue, label, icon }) => {
  return (
    <Paper className="metric-card-container" elevation={0}>
      <Box component={"div"} className="metric-card-label">
        {icon}
        {label}
      </Box>
      <Typography variant="h6">
        {fromValue}
        {" " + t("estimate.to") + " "}
        {toValue}
      </Typography>
    </Paper>
  );
};

export default MetricCard;
